export * from "./PlayableSolitaire";
export { default } from "./PlayableSolitaire";
